var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 157,
    viewBox: "0 0 124 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61968 153.6C7.61968 153.6 2.71969 155.7 16.1197 156.3C29.6197 156.9 100.72 157.2 108.02 156.3C115.32 155.4 123.52 154.3 109.72 153.1C99.3197 152.2 84.0197 152.3 73.4197 152C54.3197 151.5 13.4197 151.7 7.61968 153.6Z",
    fill: "#1B1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 68.5C58.6 68.1 57.8333 65 58 63.5L63 61.5L68.5 64C68.5 67.2 64.8333 68.3333 63 68.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7197 13.6C32.7197 13.6 27.4197 3.50001 18.1197 4.80001C8.81969 6.10001 4.51969 20.9 14.8197 29.5C25.2197 38 32.7197 13.6 32.7197 13.6Z",
    fill: "#1B1C1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4197 13.6C94.4197 13.6 99.7197 3.50001 109.02 4.80001C118.32 6.10001 122.62 20.9 112.32 29.5C101.92 38 94.4197 13.6 94.4197 13.6Z",
    fill: "#1B1C1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9197 154.5C43.1197 155.2 30.1197 156.4 18.6197 153C21.9197 150.5 38.4197 138.8 44.8197 141.4C53.3197 144.9 53.1197 152.9 52.9197 154.5Z",
    fill: "#F9C8A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.12 153C93.6197 156.5 80.7197 155.2 70.8197 154.5C70.7197 152.9 70.4197 145 78.9197 141.4C85.4197 138.7 101.82 150.5 105.12 153Z",
    fill: "#F9C8A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.22 152.9C101.92 150.4 85.4197 138.7 79.1197 141.3C70.6197 144.9 70.8197 152.8 71.0197 154.4C68.4197 154.2 66.0197 154.1 63.9197 154.1C63.3197 154.1 62.7197 154.1 62.0197 154.1C61.4197 154.1 60.8197 154.1 60.1197 154.1C58.0197 154.1 55.6197 154.2 53.0197 154.4C53.1197 152.8 53.4197 144.9 44.9197 141.3C38.5197 138.6 22.1197 150.4 18.7197 152.9C-0.180307 147.2 -4.28031 129 4.21969 74.9C4.61969 72.5 5.01969 70.1 5.41969 67.6C5.91969 64.5 6.51969 61.6 7.11969 58.8C7.51969 57.1 7.91969 55.5 8.21969 53.9C9.41969 49 10.8197 44.5 12.3197 40.4C23.6197 9.40001 42.7197 0.2 62.0197 0C81.3197 0.2 100.32 9.40001 111.72 40.4C113.22 44.5 114.62 49 115.82 53.9C116.22 55.5 116.62 57.1 116.92 58.8C117.52 61.6 118.12 64.5 118.62 67.6C119.02 70.1 119.42 72.5 119.82 74.9C128.12 128.9 124.02 147.2 105.22 152.9Z",
    fill: "#F4F5F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7197 63.6C57.7197 63.6 58.1197 68.1 63.0197 68.3C68.5197 68.5 68.8197 63.8 68.8197 63.8",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8197 50.4C57.1197 50.5 56.1197 52.4 57.2197 53.8C58.3197 55.2 60.0197 56.5 62.7197 56.7C65.6197 56.9 67.6197 55.5 68.8197 53.9C69.8197 52.6 68.9197 50.7 67.3197 50.6C64.9197 50.5 61.7197 50.3 58.8197 50.4Z",
    fill: "#1B1C1E",
    stroke: "#1B1C1E",
    strokeWidth: 1.3738,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3197 56.7C63.3197 56.7 63.5197 61 63.4197 61.3C63.3197 61.6 58.6197 64.4 52.4197 63.8",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4197 61.4C63.4197 61.4 67.0197 64.4 73.6197 64.7",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1197 52.1C43.9857 52.1 47.1197 48.966 47.1197 45.1C47.1197 41.234 43.9857 38.1 40.1197 38.1C36.2537 38.1 33.1197 41.234 33.1197 45.1C33.1197 48.966 36.2537 52.1 40.1197 52.1Z",
    fill: "#1B1C1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9197 52.1C89.7857 52.1 92.9197 48.966 92.9197 45.1C92.9197 41.234 89.7857 38.1 85.9197 38.1C82.0537 38.1 78.9197 41.234 78.9197 45.1C78.9197 48.966 82.0537 52.1 85.9197 52.1Z",
    fill: "#1B1C1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8197 90.5C62.8197 89.4 61.1197 89.4 60.1197 90.5C57.3197 93.4 52.2197 99.8 51.3197 108.4C50.2197 119.6 56.3197 124 61.3197 124.2C66.3197 124.3 73.5197 120.1 72.1197 108.4C70.9197 99.2 66.4197 93.3 63.8197 90.5Z",
    fill: "#FFCB6E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4197 1.59999C75.4197 13.4 69.5197 24.7 63.0197 24.5C50.1197 24.2 48.4197 1.59999 48.4197 1.59999C53.0197 0.499991 57.6197 0 61.9197 0C66.2197 0 70.8197 0.499991 75.4197 1.59999Z",
    fill: "#CECECE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9197 154.5C52.9197 154.7 52.9197 154.8 52.9197 154.8",
    stroke: "#1B1C1E",
    strokeWidth: 1.3037,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8197 155.1C44.8197 155.1 44.7197 151.7 44.2197 150.6",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6197 155.3C37.6197 155.3 36.9197 152.4 35.8197 151.7",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8197 141.4C44.8197 141.4 45.6197 139.7 45.8197 136",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9197 154.8C70.9197 154.8 70.9197 154.7 70.9197 154.5",
    stroke: "#1B1C1E",
    strokeWidth: 1.3037,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0197 155.1C79.0197 155.1 79.1197 151.7 79.6197 150.6",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2197 155.3C86.2197 155.3 86.9197 152.4 88.0197 151.7",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0197 141.4C79.0197 141.4 78.2197 139.7 78.0197 136",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4197 83.4C39.4197 83.4 47.1197 93.6 56.1197 100.6C60.8197 104.2 63.7197 111.5 58.4197 115.7C52.4197 120.4 19.6197 112.3 7.51968 89.7",
    fill: "#F4F5F7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4197 83.4C39.4197 83.4 47.1197 93.6 56.1197 100.6C60.8197 104.2 63.7197 111.5 58.4197 115.7C52.4197 120.4 19.6197 112.3 7.51968 89.7",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3197 109.5C61.3197 109.5 57.7197 108.8 55.9197 107.4",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0197 115.2C59.0197 115.2 54.7197 115 53.6197 114.4",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8197 83.4C84.8197 83.4 77.1197 93.6 68.1197 100.6C63.4197 104.2 60.5197 111.5 65.8197 115.7C71.8197 120.4 104.62 112.3 116.72 89.7",
    fill: "#F4F5F7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8197 83.4C84.8197 83.4 77.1197 93.6 68.1197 100.6C63.4197 104.2 60.5197 111.5 65.8197 115.7C71.8197 120.4 104.62 112.3 116.72 89.7",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9197 109.5C62.9197 109.5 66.5197 108.8 68.3197 107.4",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2197 115.2C65.2197 115.2 69.5197 115 70.6197 114.4",
    stroke: "#1B1C1E",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6197 50.3C22.1197 55.1 12.6197 54.5 8.11969 53.9C9.31969 49 10.7197 44.5 12.2197 40.4C15.2197 41.6 23.1197 45.2 22.6197 50.3Z",
    fill: "#CECECE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9197 66.9C12.2197 71.5 7.41969 73.9 4.11969 74.9C4.51969 72.5 4.91969 70.1 5.31969 67.6C5.81969 64.5 6.41968 61.6 7.01968 58.8C9.71968 59.8 13.6197 62.1 12.9197 66.9Z",
    fill: "#CECECE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 53.9C111.22 54.5 101.72 55.1 101.22 50.3C100.72 45.2 108.62 41.6 111.62 40.4C113.12 44.5 114.52 49 115.72 53.9Z",
    fill: "#CECECE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M119.72 74.9C116.42 73.8 111.62 71.5 110.92 66.9C110.22 62.1 114.12 59.8 116.82 58.8C117.42 61.6 118.02 64.5 118.52 67.6C118.92 70.1 119.32 72.6 119.72 74.9Z",
    fill: "#CECECE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2197 156.5C57.2197 156.4 57.3197 156.3 57.3197 156.1C57.2197 156.1 57.2197 156.2 57.2197 156.5Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9197 155.3L46.8197 155.7C46.9197 155.5 46.9197 155.4 46.9197 155.3Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1197 155.8C67.2197 155.8 67.2197 155.8 67.3197 155.8V155.7C67.3197 155.6 67.2197 155.8 67.1197 155.8Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8197 155.4L66.9197 155.3C66.9197 155.3 66.9197 155.4 66.8197 155.4Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2197 156.7C57.2197 156.6 57.2197 156.6 57.2197 156.5C57.1197 156.6 57.1197 156.6 57.2197 156.7Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9197 150.4C33.9197 150.3 33.8197 150.3 33.9197 150.4C33.8197 150.3 33.8197 150.3 33.9197 150.4Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6197 156.1C70.5197 155.6 70.2197 155.7 70.2197 155.9C70.3197 155.8 70.5197 156 70.6197 156.1Z",
    fill: "#080809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9197 151.8C79.8197 151.9 80.1197 151.7 80.2197 151.6C80.2197 151.6 80.0197 151.7 79.9197 151.8Z",
    fill: "#080809"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamster);
export default __webpack_public_path__ + "static/media/hamster.0ab2cdee250507a037ce14166388f2f3.svg";
export { ForwardRef as ReactComponent };